module.exports = "<div ng-if=\"visible\">\n    <ng-transclude></ng-transclude>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/js/directives/status/ifUnloaded/view.html
// module id = 1015
// module chunks = 0